// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const AddColumnIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'add-column'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M11.5 3.00006L5 3.00006C4.46957 3.00006 3.96086 3.21078 3.58578 3.58585C3.21071 3.96092 3 4.46963 3 5.00006L3 19.0001C3 19.5305 3.21071 20.0392 3.58579 20.4143C3.96086 20.7893 4.46957 21.0001 5 21.0001L19 21.0001C19.5304 21.0001 20.0391 20.7893 20.4142 20.4143C20.7893 20.0392 21 19.5305 21 19.0001L21 12.5001M15 21.0001L15 12.5001M9 21.0001L9 3.00006M15 6.00001L21 6.00001M18 3.00001L18 9.00001"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
AddColumnIcon.displayName = 'AddColumnIcon'
export { AddColumnIcon }
